<template>
  <Navbar></Navbar>
  <div class="home-page">
    <div class="home-kv">
      <div class="swiper-container kv-container" ref="swiperRefs">
        <div class="swiper-wrapper">
          <div class="swiper-slide" v-for="(item, index) in kvList" :key="index">
            <div class="img-box">
              <img :src="item.pcMedia" class="pc-pad" alt="" v-if="item.isImg == 'img'">
              <img :src="item.mmedia" class="mb-only" alt="" v-if="item.isImg == 'img'">
              <video class="pc-pad" :src="isPc ? item.pcMedia : ''" alt="" muted="muted"
                loop autoplay playsinline webkit-playsinline="true" x5-video-player-type="h5"
                x5-video-player-fullscreen="true" t7-video-player-type="inline" v-if="item.isImg !== 'img'"
                preload="metadata"></video>

              <video class="mb-only" :src="!isPc ? item.mMedia : ''" muted loop autoplay
                playsinline webkit-playsinline x5-video-player-type="h5" x5-video-orientation="portrait"
                t7-video-player-type="inline" disableRemotePlayback v-if="item.isImg !== 'img'">
              </video>
            </div>
            <div class="text-box">
              <div class="title" v-html="item.name"></div>
            </div>
            <a class="kv-btn" :href="item.button1PcUrl" v-if="item.button1Status == 1" target="_blank">
              <div class="btn-text">{{ item.button1PcName }}</div>
              <img class="btn-icon" src="/assets/index/right.png" alt="">
            </a>
          </div>
        </div>
        <div class="kv_pagination swiper-pagination">
          <div class="swiper-pagination-bullet" v-for="(item, index) in kvList" :key="index">
            <svg width="50" height="50" viewBox="0 0 300 300">
              <!-- <circle class="progress-circle" cx="150" cy="130" r="90"></circle> -->
              <circle class="progress-circle-active active" cx="130" cy="150" r="90"
                :style="index === swiper1?.realIndex ? { animationDuration: currentVideoDuration + 's' } : {}"></circle>
            </svg>
          </div>
        </div>
      </div>
    </div>

    <div class="company-data" ref="companyDataRef">
      <div class="img-box">
        <img class="pc-pad" data-src="/assets/index/company.jpg" alt="">
        <img class="mb-only" data-src="/assets/index/company-m.jpg" alt=""></img>
      </div>
      <div class="company-content scroll_center">
        <div class="company-title">
          蜂巢汽车科技集团有限公司
        </div>
        <!-- <div class="company-desc">
          创造美好生活新动力
        </div> -->
      </div>
      <div class="company-units">
        <div class="company-item">
          <div class="company-box">
            <div class="company-n" id="odometer1">
              14
            </div>
            <div class="company-unit">
              个
            </div>
          </div>
          <div class="company-desc">
            全球生产工厂
          </div>
        </div>
        <div class="company-item">
          <div class="company-box">
            <div class="company-n" id="odometer2">
              7
            </div>
            <div class="company-unit">
              个
            </div>
          </div>
          <div class="company-desc">
            全球研发中心
          </div>
        </div>
        <div class="company-item">
          <div class="company-box">
            <div class="company-n" id="odometer3">
              13100
            </div>
            <span>+</span>
            <div class="company-unit">

            </div>
          </div>
          <div class="company-desc">
            全球员工
          </div>
        </div>
        <div class="company-item">
          <div class="company-box">
            <div class="company-n" id="odometer4">
              34.49
            </div>
            <div class="company-unit">
              亿元
            </div>
          </div>
          <div class="company-desc">
            全球2025年销售额
          </div>
        </div>
        <div class="company-item">
          <div class="company-box">
            <div class="company-n" id="odometer5">
              4100
            </div>
            <span>+</span>
            <div class="company-unit">

            </div>
          </div>
          <div class="company-desc">
            全球研发人员
          </div>
        </div>
      </div>

    </div>

    <div class="product-box">
      <div class="product-list">
        <div class="product-title-box">
          <div class="product-title scroll_center ">
            <div class="product-t1">
              产品与解决方案
            </div>
            <div class="product-t2">
              以核心技术为锚点，构建动力系统、传动系统、电子单元的产品生态，为客户提供高效、高质量的智慧化出行体验
            </div>
          </div>
        </div>
        <div class="product-item" v-for="(item, index) in productList" :key="index">
          <div class="product-top">
            <div></div>
            <div class="product-btn-list scroll_center ">
              <a class="product-btn" :href="item.button2MUrl" target="_blank">
                <span>
                  {{ item.button2MName }}
                </span>
                <img src="/assets/index/right.png" alt="">
              </a>
              <a class="product-btn" :href="item.button1MUrl" target="_blank">
                <span>
                  {{ item.button1MName }}
                </span>
                <img src="/assets/index/right.png" alt="">
              </a>
            </div>
          </div>

          <div class="product-bottom">
            <div class="img-box">
              <img class="pc-pad" :src="item.pcMedia" alt="" v-if="item.isImg"></img>
              <img class="mb-only" :src="item.mmedia" alt="" v-if="item.isImg"></img>

              <video :data-src="item.pcMedia" alt="" muted loop autoplay playsinline
                webkit-playsinline="true" x5-video-player-type="h5" x5-video-player-fullscreen="true"
                t7-video-player-type="inline" v-if="item.isImg !== 'img'" preload="metadata"></video>
            </div>
            <div class="product-desc-box scroll_center">
              <div class="product-desc  ">
                <div class="product-d1">
                  {{ item.smallTitle }}
                </div>
                <div class="product-d2">
                  {{ item.smallTitleText }}
                </div>
              </div>

              <a class="product-desc-btn " :href="item.pcJumpUrl">
                <span>
                  了解更多{{ item.name }}系统
                </span>
                <img src="/assets/index/right.png" alt="">
              </a>
            </div>
          </div>

          <!-- <div class="product-bg">
            <img src="/assets/index/product-bg.png" alt=""></img>
          </div> -->
        </div>
      </div>
    </div>

    <div class="manufacture-box">
      <div class="manufacture-text">
        <div class="manufacture-title">
          智能制造
        </div>
        <div class="manufacture-desc">
          深耕汽车动力总成与智慧电子智造领域，秉承精益生产理念，打造垂直一体化智能制造平台，全球建有18座智能工厂，规划年产发动机200万台、变速器265万台、电子产品800万套。以国际高精端设备、微米级加工精度、数字化智能检测等，严控生产品质，为用户打造美好出行体验
        </div>
        <a class="manufacture-btn" href="/manufacture.html" target="_blank">
          <div class="manufacture-btn-t">
            了解更多
          </div>
          <img src="/assets/index/right.png" alt="">
        </a>

      </div>
      <div class="img-box">
        <video data-src="/assets/index/manufacture.mp4" alt="" muted loop autoplay playsinline webkit-playsinline="true"
          x5-video-player-type="h5" x5-video-player-fullscreen="true" t7-video-player-type="inline"></video>
        <!-- <video class="mb-only" data-src="/assets/index/manufacture-m.mp4" alt="" muted loop autoplay playsinline
          webkit-playsinline="true" x5-video-player-type="h5" x5-video-player-fullscreen="true"
          t7-video-player-type="inline"></video> -->

      </div>
      <div class="manufacture-master img-box">
        <img class="pc-pad" data-src="/assets/index/manufacture-master2.png" alt="">
        <img class="mb-only" data-src="/assets/index/manufacture-master2-m.png" alt="">

      </div>
    </div>

    <div class="hover-list">
      <div class="hover-left">
        <div class="hover-item">
          <div class="img-box">
            <img class="pc-pad" data-src="/assets/index/hover1.jpg" alt=""></img>
            <img class="mb-only" data-src="/assets/index/hover1-m.jpg" alt=""></img>
          </div>
          <div class="hover-text">
            <div class="hover-title">
              关于蜂巢
            </div>
            <a class="hover-link" href="/about.html">
              <span>
                了解更多
              </span>
              <img src="/assets/index/right.png" alt=""></img>
            </a>
          </div>
          <div class="hover-master"></div>
        </div>
        <div class="hover-item pc-pad">
          <div class="img-box">
            <img class="pc-pad" data-src="/assets/index/hover2.jpg" alt=""></img>
          </div>
          <div class="hover-text">
            <div class="hover-title">
              商务合作
            </div>
            <a class="hover-link" href="/contact-us.html">
              <span>
                了解更多
              </span>
              <img src="/assets/index/right.png" alt=""></img>
            </a>
          </div>
          <div class="hover-master"></div>
        </div>
        <div class="hover-item pc-pad">
          <div class="img-box">
            <img class="pc-pad" data-src="/assets/index/hover3.jpg" alt=""></img>
          </div>
          <div class="hover-text">
            <div class="hover-title">
              加入我们
            </div>
            <a class="hover-link" href="/join-us.html">
              <span>
                了解更多
              </span>
              <img src="/assets/index/right.png" alt=""></img>
            </a>
          </div>
          <div class="hover-master"></div>
        </div>
        <div class="hover-item mb-only">
          <div class="img-box">
            <img data-src="/assets/index/hover4-m.jpg" alt=""></img>
          </div>
          <div class="hover-text">
            <div class="hover-title">
              新闻资讯
            </div>
            <a class="hover-link" href="/news.html">
              <span>
                了解更多
              </span>
              <img src="/assets/index/right.png" alt=""></img>
            </a>
          </div>
          <div class="hover-master"></div>
        </div>

        <div class="hover-item mb-only">
          <div class="img-box">
            <img data-src="/assets/index/hover5-m.jpg" alt=""></img>
          </div>
          <div class="hover-text">
            <div class="hover-title">
              智能制造
            </div>
            <a class="hover-link" href="/manufacture.html">
              <span>
                了解更多
              </span>
              <img src="/assets/index/right.png" alt=""></img>
            </a>
          </div>
          <div class="hover-master"></div>
        </div>
      </div>
      <div class="hover-right">
        <div class="hover-item pc-pad">
          <div class="img-box">
            <img data-src="/assets/index/hover4.jpg" alt=""></img>
          </div>
          <div class="hover-text">
            <div class="hover-title">
              新闻资讯
            </div>
            <a class="hover-link" href="/news.html">
              <span>
                了解更多
              </span>
              <img src="/assets/index/right.png" alt=""></img>
            </a>
          </div>
          <div class="hover-master"></div>
        </div>

        <div class="hover-item pc-pad">
          <div class="img-box">
            <img data-src="/assets/index/hover5.jpg" alt=""></img>
          </div>
          <div class="hover-text">
            <div class="hover-title">
              智能制造
            </div>
            <a class="hover-link" href="/manufacture.html">
              <span>
                了解更多
              </span>
              <img src="/assets/index/right.png" alt=""></img>
            </a>
          </div>
          <div class="hover-master"></div>
        </div>


        <div class="hover-item mb-only">
          <div class="img-box">
            <img data-src="/assets/index/hover2-m.jpg" alt=""></img>
          </div>
          <div class="hover-text">
            <div class="hover-title">
              商务合作
            </div>
            <a class="hover-link" href="/contact-us.html">
              <span>
                了解更多
              </span>
              <img src="/assets/index/right.png" alt=""></img>
            </a>
          </div>
          <div class="hover-master"></div>
        </div>
        <div class="hover-item mb-only">
          <div class="img-box">
            <img data-src="/assets/index/hover3-m.jpg" alt=""></img>
          </div>
          <div class="hover-text">
            <div class="hover-title">
              加入我们
            </div>
            <a class="hover-link" href="/join-us.html">
              <span>
                了解更多
              </span>
              <img src="/assets/index/right.png" alt=""></img>
            </a>
          </div>
          <div class="hover-master"></div>
        </div>

      </div>

    </div>
  </div>
  <Footer></Footer>
</template>

<script setup>
import { ref, onMounted, nextTick, onUnmounted } from 'vue';
import Navbar from '@/components/Navbar.vue';
import Footer from '@/components/Footer.vue';
import Swiper from 'swiper/bundle';
import 'swiper/swiper-bundle.css';
import Odometer from 'odometer';
import 'odometer/themes/odometer-theme-default.css';
import $ from 'jquery'
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);

import { getKvvList, getMatrixList } from '@/utils/common.js'


const kvList = ref([])
const swiperRefs = ref(null);
const swiperInstances = ref([]);
const productList = ref([
])

const bgColors = ref([
  'linear-gradient( 136deg, #65AAE2 0%, #398FE5 100%)',
  'linear-gradient( 136deg, #52C9BA 0%, #46B3AE 100%)',
  'linear-gradient( 316deg, #9BA4B3 0%, #B8BCC4 100%)',
]);


const companyDataRef = ref(null);
let observer = null;


// 判断是否是视频
const isVideo = (url) => {
  return /\.(mp4|mov|wmv|avi|asf|rm|rmvb|flv|mkv)$/.test(url);
};
let swiper1
const initAllSwipers = async () => {
  destroySwipers();
  await nextTick();
  const el = swiperRefs.value;
  if (el) {
    swiper1 = new Swiper(el, {
      loop: true,
      effect: isPc.value ? "fade" : "slide",
      fadeEffect: {
        crossFade: true,
      },
      autoplay: {
        delay: 10000,
        disableOnInteraction: false,
      },
      on: {
        init: function (swiper) {
          handleActiveVideo(swiper);
        },
        // 切换开始预执行
        slideChangeTransitionStart(swiper) {
          document.querySelectorAll('.progress-circle-active').forEach(circle => {
            circle.style.animation = 'none';
            circle.offsetHeight; // 触发重绘
            circle.style.animation = '';
          })
          // handleActiveVideo(swiper);
          setTimeout(() => handleActiveVideo(swiper), 150);
        },
        // 切换动画完全结束后再执行一次兜底
        slideChange(swiper) {
          // setTimeout(() => handleActiveVideo(swiper), 100);
        },
      },
    });
    swiperInstances.value.push(swiper1);
  }
};

const currentVideoDuration = ref(10)
const handleActiveVideo = (swiper) => {
  const swiperIndex = swiper.realIndex;
  $('.kv_pagination .swiper-pagination-bullet').removeClass("swiper-pagination-bullet-active");
  $('.kv_pagination .swiper-pagination-bullet').eq(swiperIndex).addClass("swiper-pagination-bullet-active");

  const allVideos = document.querySelectorAll(".kv-container .swiper-slide video");
  allVideos.forEach(video => {
    video.pause();
    video.currentTime = 0;
  });

  const activeSlideDom = document.querySelector(".kv-container .swiper-slide-active");
  if (!activeSlideDom) return;

  const videos = isPc.value ? activeSlideDom.querySelectorAll('video.pc-pad') : activeSlideDom.querySelectorAll('video.mb-only');
  videos.forEach(video => {
    const updateSwiperDelay = (duration) => {
      if (!swiper1) return;
      swiper1.params.autoplay.delay = duration * 1000 - 500;
      swiper1.autoplay.stop();
      swiper1.autoplay.start();
      // 关键：同步更新环形进度条动画时长
      currentVideoDuration.value = duration;
    };

    if (video.readyState >= 1) {
      const totalTime = video.duration;
      updateSwiperDelay(totalTime);
    } else {
      video.addEventListener('loadedmetadata', function getDur() {
        const totalTime = this.duration;
        updateSwiperDelay(totalTime);
        this.removeEventListener('loadedmetadata', getDur);
      })
    }
    video.play().catch(() => { });
  });
};


const destroySwipers = () => {
  swiperInstances.value.forEach(swiper => {
    if (swiper && swiper.destroy) {
      swiper.destroy(true, true);
    }
  });
  swiperInstances.value = [];
};
const odometerConfigs = [
  { id: 'odometer1', value: 18 },
  { id: 'odometer2', value: 7 },
  { id: 'odometer3', value: 13100 },
  { id: 'odometer4', value: 345 },
  { id: 'odometer5', value: 4100 }
];

const odometerInstances = {};

const initOdometer = () => {
  nextTick(() => {
    odometerConfigs.forEach(({ id, value }) => {
      const el = document.querySelector(`#${id}`);
      if (!el) return;

      if (odometerInstances[id]) {
        odometerInstances[id].update(0);
        setTimeout(() => {
          odometerInstances[id].update(value);
        }, 10);
        return;
      }
      odometerInstances[id] = new Odometer({
        el,
        value: 0,
        duration: 250,
        format: '(ddd).dd',
        theme: 'default'
      });

      setTimeout(() => {
        odometerInstances[id].update(value);
      }, 0);
    });
  });
};

const initObserver = () => {
  if (!companyDataRef.value) return;

  if (observer) {
    observer.disconnect();
  }

  observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        setTimeout(() => {
          initOdometer();
        }, 500);
      }
    });
  }, {
    threshold: 0.6,
    rootMargin: '0px'
  });

  // 持续监听目标元素
  observer.observe(companyDataRef.value);
};
const gsapProduct = () => {
  const productCount = productList.value.length;
  if (productCount === 0) return;

  let lastIndex = -1;

  ScrollTrigger.create({
    trigger: ".product-box",
    start: "top center",
    end: "bottom center",
    scrub: 0.1,
    onUpdate: self => {
      let progress = self.progress;
      let singleProductProgress = 1 / productCount;
      let currentIndex = Math.floor(progress / singleProductProgress);
      currentIndex = Math.min(currentIndex, productCount - 1);
      currentIndex = Math.max(currentIndex, 0);
      if (currentIndex !== lastIndex) {
        document.querySelector('.product-list').style.background = productList.value[currentIndex].bgColor;
        lastIndex = currentIndex;
      }
    }
  });
};

const gsapManufacture = () => {
  const imgScaleAnimation = gsap.timeline({ paused: true });
  const playSubsequentAutoAnimation = () => {
    gsap.timeline()
      .to(".manufacture-box .manufacture-text .manufacture-title", {
        duration: 0.5,
        opacity: 1,
        x: "0",
      }, "step3")
      .to(".manufacture-box .manufacture-text .manufacture-desc", {
        duration: 0.5,
        opacity: 1,
        x: "0",
      }, "step3")
      .to(".manufacture-box .manufacture-text .manufacture-btn", {
        duration: 0.5,
        opacity: 1,
        x: "0",
        // delay: 1
      }, "step3");
  };
  gsap.set(".manufacture-box .manufacture-text .manufacture-title", { opacity: 0, x: "2rem" });
  gsap.set(".manufacture-box .manufacture-text .manufacture-desc", { opacity: 0, x: "2rem" });
  gsap.set(".manufacture-box .manufacture-text .manufacture-btn", { opacity: 0, x: "2rem" });
  ScrollTrigger.create({
    animation: imgScaleAnimation,
    trigger: ".manufacture-box",
    start: "top center",
    end: "bottom bottom",
    scrub: true,
    anticipatePin: 1,
    onUpdate: (self) => {
      if (self.progress >= 0.99 && !self._animationCompleted) {
        self._animationCompleted = true;
        playSubsequentAutoAnimation();
      }
      if (self.progress < 0.99) {
        self._animationCompleted = false;
        gsap.set(".manufacture-box .manufacture-text .manufacture-title", { opacity: 0, x: "2rem" });
        gsap.set(".manufacture-box .manufacture-text .manufacture-desc", { opacity: 0, x: "2rem" });
        gsap.set(".manufacture-box .manufacture-text .manufacture-btn", { opacity: 0, x: "2rem" });
      }
    }
  });
}

const timeManufacture = () => {
  const coverAnimation = gsap.timeline({ paused: true });
  gsap.set(".manufacture-box", { width: "100%" });
  coverAnimation
    .to(".manufacture-box", {
      duration: 3,
      width: "100%",
    }, "step1")

  ScrollTrigger.create({
    animation: coverAnimation,
    trigger: ".manufacture-box",
    start: "bottom bottom",
    end: () => `+=${coverAnimation.duration() * 300}`,
    scrub: true,
    pin: true,
    anticipatePin: 1,
  });
}

$(window).scroll(() => {
  var scrollCenter = $('.scroll_center');
  var productBox = $('.product-box');
  var windowHeight = $(window).height();
  var scrollTop = $(window).scrollTop();

  scrollCenter.each(function () {
    var element = $(this);
    var elementOffset = element.offset().top;
    if (scrollTop + windowHeight >= elementOffset) {
      element.addClass('active');
    } else {
      element.removeClass('active');
    }
  })

  productBox.each(function () {
    var element = $(this);
    var elementOffset = element.offset().top;
    if (scrollTop + windowHeight >= elementOffset) {
      var videoList = element.find('video');
      videoList.each(function () {
        var $video = $(this);
        if (!$video.attr('src') && $video.data('src')) {
          $video.attr('src', $video.data('src'));
          $video.removeAttr('data-src');
        }
      })
    }
  })
})

const GetKvData = async () => {
  try {
    const kvData = await getKvvList({
      status: 2
    });
    kvData.rows.forEach(item => {
      if (isVideo(item.pcMedia)) {
        item.isImg = 'video';
      } else {
        item.isImg = 'img';
      }

      // 核心修正：匹配转义后的 \n（\\n）
      item.name = (item.name || '').toString().replace(/\\n/g, '<br>');

      kvList.value.push(item);
    });

    nextTick(() => {
      initAllSwipers();
    });
  } catch (error) {
    console.log(error)
  }
};
const isPc = ref(window.innerWidth > 768)
const GetMatrixData = async () => {
  try {
    const matrixData = await getMatrixList();
    matrixData.rows.forEach((item, index) => {
      item.bgColor = bgColors.value[index]
      if (isVideo(item.pcMedia)) {
        item.isImg = 'video';
      } else {
        item.isImg = 'img';
      }
    });

    productList.value = matrixData.rows;
    gsapProduct()
    gsapManufacture()
    if (isPc.value) {
      timeManufacture()
    }
  } catch (error) {
    console.log(error)
  }
};


onMounted(() => {
  GetKvData();
  GetMatrixData();
  nextTick(() => {
    initObserver();
  });
});

onUnmounted(() => {
  if (observer) {
    observer.disconnect();
    observer = null;
  }
});
</script>

<script>
export const pageConfig = {
  title: '蜂巢汽车官网',
  keywords: '蜂巢,蜂巢汽车,发动机,变速箱,电子',
  description: '蜂巢汽车科技集团有限公司，是一家掌握从传统动力到混合动力再到纯电动力（含控制器）全领域动力总成、汽车智能化集成系统等核心技术的零部件企业，具备完整的软、硬件产业链；能为客户提供高效节能环保的汽车动力总成、智能化出行解决方案',
  outputPath: 'index.html'
};

import { createApp } from 'vue';
import App from './index.vue';
import store from '@/store/index';
import "@/assets/styles/global.scss"

function mountApp() {
  const appNode = document.getElementById('app');
  if (appNode) {
    if (appNode._vueApp) {
      appNode._vueApp.unmount();
      delete appNode._vueApp;
    }
    const app = createApp(App);
    app.use(store);
    appNode._vueApp = app.mount(appNode);
  }
}

// 页面加载完成后挂载
document.addEventListener('DOMContentLoaded', mountApp);

if (module.hot) {
  module.hot.accept('./index.vue', () => {
    mountApp();
  });
}
</script>

<style lang="scss">
.home-kv {
  width: 100%;
  height: 100vh;
  position: relative;

  .img-box {
    width: 100%;
    height: 100vh;

    img,
    video {
      width: 100%;
      height: 100%;
      // transform: scale(1.4);
    }
  }

  .text-box {
    position: absolute;
    left: 1.56rem;
    top: 3.3rem;
    color: #fff;
    z-index: 1;
    width: 30%;
    transform: translateY(2rem);
    opacity: 0;

    .title {
      font-size: 0.5rem;
      font-weight: 800;
    }

    .text {
      font-size: 0.2rem;
      margin-top: 0.28rem;
      font-weight: 300;
    }
  }

  .kv-btn {
    position: absolute;
    left: 1.56rem;
    top: 5.95rem;
    z-index: 1;
    background: linear-gradient(135deg, #E70012 0%, #EA5433 100%);
    width: 1.71rem;
    height: 0.45rem;
    border-radius: 0.26rem;
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 0.18rem;
    color: #fff;
    transform: translateY(2rem);
    opacity: 0;

    .btn-text {
      font-size: 0.13rem;
      font-weight: 400;
      width: 55%;
      text-align: center;
    }

    .btn-icon {
      width: 0.25rem;
      height: 0.25rem;
      border-radius: 50%;

      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }

  }

  .swiper-slide {
    background: #000;
    overflow: hidden;
  }

  .swiper-slide-active {
    .img-box {

      img,
      video {
        transform: scale(1);
        transition: all 0.5s ease-in-out;
      }
    }

    .text-box,
    .kv-btn {
      transform: translateY(0);
      opacity: 1;
      transition: all 1s ease-in-out;
    }
  }

  .kv_pagination {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 0.28rem;
    left: 1.56rem;
    bottom: 0.61rem;
    width: auto;

    .swiper-pagination-bullet {
      width: 0.09rem;
      height: 0.09rem;
      border-radius: 0.09rem;
      background: rgba(255, 255, 255, 0.53);
      opacity: 1;
      position: relative;

      svg {
        display: none;

        transform: translate(-50%, -50%);
        position: absolute;
        left: 50%;
        top: 0;
        transform: translate(-50%, -50%);

      }
    }

    .swiper-pagination-bullet-active {
      background: #E70012;

      svg {
        display: block;

        .progress-circle {
          fill: none;
          background: rgba(255, 255, 255, 0.53);
          stroke-width: 10;
        }

        .progress-circle-active {
          fill: none;
          stroke: #E70012;
          stroke-width: 10;
          stroke-linecap: round;
          stroke-dasharray: 565.48;
          stroke-dashoffset: 565.48;
          transform: rotate(-90deg);
          transform-origin: center;
          animation: progress linear forwards;
        }

        @keyframes progress {
          to {
            stroke-dashoffset: 0;
          }
        }
      }
    }

  }

}

.company-data {
  width: 100%;
  height: 100vh;
  overflow: hidden;
  position: relative;

  .img-box {
    width: 100%;
    height: 100%;

    img,
    video {
      width: 100%;
      height: 100%;
    }
  }

  .company-content {
    position: absolute;
    top: 2rem;
    left: 0;
    width: 100%;
    text-align: center;

    .company-title {
      font-size: 0.55rem;
      font-weight: 500;
      color: #fff;
    }

    .company-desc {
      font-size: 0.33rem;
      color: #fff;
      margin-top: 0.22rem;
      font-weight: 400;
      white-space: nowrap;
    }

    &.active {
      transform: translateY(0);
      opacity: 1;
    }
  }

  .company-units {
    position: absolute;
    bottom: 0.84rem;
    left: 0;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 1.3rem;

    .company-item {
      color: #fff;

      .company-box {
        display: flex;
        align-items: flex-start;
        gap: 0.18rem;
        line-height: 1;
        font-size: 0.6rem;

        .company-n {
          font-size: 0.6rem;
          font-weight: 800;
          line-height: 1;
          width: 1.94rem;
          white-space: nowrap;
          /* 强制数字不换行 */
          width: auto;
        }

        .company-unit {
          font-size: 0.25rem;
          font-weight: 300;
        }
      }

      .company-desc {
        font-weight: 300;
        font-size: 0.2rem;
        margin-top: 0.18rem;
        white-space: nowrap;
      }
    }

    &.active {
      transform: translateY(0);
      opacity: 1;
    }
  }

}

.product-box {
  position: relative;
  width: 100%;
  height: auto;

  .product-list {
    width: 100%;
    height: 100%;
    position: relative;
    // background: #3B4655;
    transition: all 0.5s ease-in-out;
    padding-top: 1.5rem;
    background-size: auto;

    .product-bg {
      width: 100%;
      height: 100%;
      position: absolute;
      left: 0;
      top: 0;

      img {
        width: 100%;
        height: 100%;
      }
    }

    .product-title-box {
      width: 100%;
      height: calc(100% - 8rem);
      position: absolute;
      left: 0;
      top: 1rem;
    }

    .product-title {
      width: 40%;
      position: sticky;
      left: 1.56rem;
      top: 1.56rem;
      z-index: 18;
      will-change: transform, position;
      backface-visibility: hidden;
      transform: translateZ(0);
      padding-top: 0.5rem;

      .product-t1 {
        font-size: 0.4rem;
        font-weight: 600;
        margin-bottom: 0.34rem;
        // background: linear-gradient(129deg, #E70012 0%, #FFFFFF 55.37%, #ED6D00 100%);
        // -webkit-background-clip: text;
        // background-clip: text;
        // -webkit-text-fill-color: transparent;
        color: #fff;
        display: inline;
      }

      .product-t2 {
        font-size: 0.18rem;
        font-weight: 300;
        line-height: 0.35rem;
        color: #fff;
      }

    }

    .title-absolute {
      position: absolute !important;
      bottom: 7rem !important;
      top: auto !important;
    }

    .product-item {
      width: calc(100% - 3.12rem);
      height: calc(100% - 2.68rem);
      z-index: 4;
      padding: 1.12rem 1.56rem 1.12rem;
      color: #fff;
      transition: all 0.3s ease-in-out;
      position: relative;

      .product-top {
        display: flex;
        justify-content: space-between;
        align-items: flex-end;
        // width: 100%;
        margin-bottom: 0.78rem;



        .product-btn-list {
          display: flex;
          justify-content: flex-end;
          align-items: center;
          gap: 0.16rem;

          .product-btn {
            width: 1.7rem;
            height: 0.45rem;
            border-radius: 0.26rem;
            border: 1px solid #fff;
            display: flex;
            justify-content: center;
            align-items: center;
            color: #fff;

            span {
              font-size: 0.13rem;
              font-weight: 400;
              display: block;
              width: 60%;
              text-align: center;
            }

            img {
              width: 0.25rem;
              height: 0.25rem;
              border-radius: 50%;
            }
          }
        }
      }

      .product-bottom {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-top: 0.78rem;

        .img-box {
          width: 60%;
          border-radius: 0.26rem;
          overflow: hidden;
        }

        .product-desc-box {
          padding: 0.83rem 1.18rem 1.26rem;
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          width: calc(40% - 2.38rem);
          height: 3.04rem;

          .product-desc {
            .product-d1 {
              font-size: 0.29rem;
            }

            .product-d2 {
              font-size: 0.18rem;
              font-weight: 300;
              margin-top: 0.28rem;
              text-align: justify;
            }
          }

          .product-desc-btn {
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding: 0 0.23rem;
            border: 1px solid #fff;
            border-radius: 0.26rem;
            width: 1.57rem;
            height: 0.37rem;

            span {
              font-size: 0.1rem;
              font-weight: 400;
            }

            img {
              width: 0.2rem;
              height: 0.2rem;
              border-radius: 50%;
            }
          }
        }

      }
    }

    .product-item:nth-child(1) {
      padding-top: 2.24rem;
    }
  }
}


.scroll_center {
  transform: translateY(2rem);
  transition: all 1.5s ease-in-out;
  opacity: 0;

  &.active {
    transform: translateY(0);
    opacity: 1;
  }
}

.manufacture-box {
  width: 100%;
  height: 110vh;
  position: relative;

  // background: linear-gradient(90deg, rgb(94, 115, 136), rgb(80, 105, 124));

  .manufacture-master {
    width: 100%;
    height: 100%;
    position: absolute;
    left: 0;
    top: 0;
    z-index: 3;
  }

  .manufacture-text {
    margin-bottom: 0.58rem;
    color: #000;
    display: flex;
    // align-items: center;
    flex-direction: column;
    position: absolute;
    right: 1.56rem;
    top: 2.38rem;
    z-index: 5;
    width: 3.45rem;

    .manufacture-title {
      font-size: 0.4rem;
      width: 100%;
    }

    .manufacture-desc {
      font-size: 0.18rem;
      font-weight: 300;
      margin-top: 0.27rem;
      text-align: justify;
    }

    .manufacture-icon-list {
      display: flex;
      align-items: center;
      justify-content: space-between;
      gap: 0.7rem;
      margin-top: 3rem;

      .manufacture-icon-item {
        display: flex;
        flex-direction: column;
        align-items: center;

        .manufacture-icon {
          width: 0.4rem;
          height: auto;
          object-fit: cover;
          margin-bottom: 0.41rem;
        }

        .manufacture-icon-t {
          font-size: 0.17rem;
          font-weight: 400;
          color: #000;
        }
      }
    }

    .manufacture-btn {
      background: linear-gradient(135deg, #E70012 0%, #EA5433 100%);
      width: 1.71rem;
      height: 0.45rem;
      border-radius: 0.26rem;
      display: flex;
      justify-content: center;
      align-items: center;
      gap: 0.18rem;
      color: #fff;
      margin-top: 0.27rem;

      .manufacture-btn-t {
        font-size: 0.13rem;
        font-weight: 400;
        width: 55%;
        text-align: center;
      }

      img {
        width: 0.25rem;
        height: 0.25rem;
        border-radius: 50%;
        object-fit: cover;
      }
    }
  }
}

.hover-list {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 0.2rem;
  padding: 1.03rem 1.56rem;

  .hover-item {
    width: 100%;
    position: relative;
    cursor: pointer;
    border-radius: 0.26rem;
    overflow: hidden;

    .hover-text {
      position: absolute;
      left: 0.43rem;
      bottom: 0.34rem;
      color: #fff;
      height: 0.4rem;
      overflow: hidden;
      transition: all 0.6s ease-in-out;
      display: flex;
      flex-direction: column;
      justify-content: space-between;

      .hover-title {
        font-size: 0.27rem;
        font-weight: 400;
        line-height: 1;
        margin-bottom: 0.3rem;
        margin-top: 0.06rem;
      }

      .hover-link {
        font-size: 0.18rem;
        display: flex;
        align-items: center;
        gap: 0.1rem;

        img {
          width: 0.2rem;
          height: 0.2rem;
          border-radius: 50%;
          object-fit: cover;
        }
      }

      z-index: 3;
    }

    .hover-master {
      width: 100%;
      height: 0;
      position: absolute;
      left: 0;
      bottom: 0;
      transition: all 0.6s ease-in-out;
      z-index: 2;
    }

    &:hover {
      .hover-text {
        height: 1rem;
      }
    }
  }

  .hover-left {
    width: calc(67% - 0.1rem);
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 0.2rem;
    flex-wrap: wrap;

    .hover-item:nth-child(n+2) {
      width: calc(50% - 0.1rem);
    }
  }

  .hover-right {
    width: calc(33% - 0.1rem);
    justify-content: space-between;
    align-items: center;
    gap: 0.2rem;
    flex-wrap: wrap;
    display: flex;
    flex-direction: column;
  }
}

@media (max-width: 768px) {
  .home-kv {
    .text-box {
      left: 0.45rem;
      top: 2.89rem;
      z-index: 1;
      width: 90%;

      .title {
        font-size: 0.6rem;
        font-weight: 800;
      }

      .text {
        font-size: 0.2rem;
        margin-top: 0.28rem;
        font-weight: 300;
      }
    }

    .kv-btn {
      left: calc(50% - 2.01rem);
      top: auto;
      bottom: 2.31rem;
      width: 4.02rem;
      height: 0.9rem;
      border-radius: 0.45rem;
      gap: 0.18rem;

      .btn-text {
        font-size: 0.23rem;
        font-weight: 400;
        width: 66%;
        text-align: center;
      }

      .btn-icon {
        width: 0.57rem;
        height: 0.57rem;
        border-radius: 50%;

        img {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }
      }

    }

    .kv_pagination {
      display: flex;
      justify-content: center;
      align-items: center;
      gap: 0.43rem;
      left: 50%;
      transform: translateX(-50%);
      bottom: 0.61rem;
      width: auto;

    }

    .img-box {
      position: relative;
      overflow: hidden;

      video {

        img,
        video {
          width: 100%;
          height: 100%;
          object-fit: cover;
          display: block;
          transform: translateZ(0);
          -webkit-transform: translateZ(0);
        }

        video {
          pointer-events: none;
        }
      }
    }

  }

  .company-data {
    background: #000;

    .company-content {
      position: absolute;
      top: 1.5rem;
      left: 0;
      width: 100%;
      text-align: center;

      .company-title {
        font-size: 0.5rem;
        font-weight: 500;
      }

      .company-desc {
        font-size: 0.26rem;
        color: #fff;
        margin-top: 0.22rem;
        font-weight: 400;
        white-space: nowrap;
      }

      &.active {
        transform: translateY(0);
        opacity: 1;
      }
    }

    .company-units {
      position: absolute;
      bottom: 50%;
      left: 50%;
      transform: translate(-50%, 50%);
      width: calc(100% - 2.2rem);
      display: flex;
      justify-content: space-between;
      align-items: center;
      flex-wrap: wrap;
      gap: 0.2rem;
      row-gap: 0.76rem;
      background: linear-gradient(180deg, rgba(255, 255, 255, 0.21) 0%, rgba(213, 229, 255, 0.1) 100%);
      border-radius: 0.24rem;
      border: 2px solid rgba(255, 255, 255, 0.27);
      padding: 0.72rem 0.45rem;

      .company-item {
        color: #fff;
        width: calc(50% - 0.1rem);

        .company-box {
          font-size: 0.4rem;
          line-height: 1;
          gap: 0;

          .company-n {
            font-size: 0.6rem;
            font-weight: 800;
            width: 1.94rem;
          }

          .company-unit {
            font-size: 0.25rem;
            font-weight: 300;
          }
        }

        .company-desc {
          font-weight: 300;
          font-size: 0.2rem;
          margin-top: 0.18rem;
          white-space: nowrap;
        }
      }
    }

  }

  .product-box {
    .product-list {
      padding-top: 2.3rem;

      .product-title-box {
        top: 1.38rem;
      }

      .product-title {
        width: 90%;
        left: 0.45rem;
        padding-top: 0;

        .product-t1 {
          font-size: 0.42rem;
          font-weight: 500;
        }

        .product-t2 {
          font-size: 0.2rem;
          font-weight: 300;
          color: #fff;
          margin-top: 0.18rem;
        }
      }

      .product-item {
        width: calc(100% - 0.9rem);
        padding: 0.5rem 0.45rem;

        .product-top {
          margin-bottom: 0.35rem;
          justify-content: flex-start;

          .product-btn-list {
            justify-content: flex-start;
            gap: 0.26rem;
            display: none;

            .product-btn {
              width: 3.17rem;
              height: 0.64rem;
              border-radius: 0.32rem;

              img {
                width: 0.34rem;
                height: 0.34rem;
              }

              span {
                font-size: 0.19rem;
              }
            }
          }
        }

        .product-bottom {
          flex-direction: column;
          gap: 0.54rem;
          margin-top: 0.39rem;

          .img-box {
            width: 100%;
          }

          .product-desc-box {
            width: 100%;
            padding: 0;
            height: auto;
            gap: 0.78rem;

            .product-desc {
              .product-d1 {
                font-size: 0.36rem;
              }

              .product-d2 {
                font-size: 0.2rem;
                font-weight: 400;
              }
            }

            .product-desc-btn {
              width: 2.5rem;
              height: 0.64rem;
              border-radius: 0.32rem;

              span {
                font-size: 0.22rem;
                width: 90%;
                display: block;
                text-align: center;
              }

              img {
                width: 0.34rem;
                height: 0.34rem;
              }
            }
          }
        }
      }
    }
  }

  .manufacture-box {
    background: unset;
    height: 100vh;

    .manufacture-text {
      right: 50%;
      transform: translateX(50%);
      top: 1.1rem;
      width: 5.92rem;
      text-align: center;
      align-items: center;

      .manufacture-title {
        font-size: 0.42rem;
      }


      .manufacture-desc {
        font-size: 0.26rem;
        margin-top: 0.36rem;
        line-height: 0.4rem;

      }

      .manufacture-btn {
        width: 2.16rem;
        height: 0.57rem;
        margin-top: 0.36rem;
        border-radius: 0.28rem;

        .manufacture-btn-t {
          font-size: 0.16rem;
        }

        img {
          width: 0.31rem;
          height: 0.31rem;
        }
      }
    }

    .img-box {
      height: 100%;

      video {
        height: 100%;
      }
    }
  }

  .hover-list {
    padding: 1.1rem 0.45rem;
    flex-direction: column;
    gap: 0.3rem;

    .hover-item {
      .hover-text {
        height: 1rem;

        .hover-title {
          margin-bottom: 0.1rem;
        }
      }
    }

    .hover-left {
      width: 100%;
      flex-direction: row;
      flex-wrap: wrap;
      gap: 0.3rem;

      .hover-item {
        width: 100%;

        &:nth-child(n+2) {
          width: 100%;
        }
      }
    }

    .hover-right {
      width: 100%;
      flex-direction: row;
      flex-wrap: wrap;
      gap: 0.3rem;

      .hover-item {
        width: 100%;
      }
    }
  }
}
</style>